'use client';
import { noop } from '@s7/utils';
import { isBrowser } from '../platform/isBrowser.js';

const browserAction = (fn)=>isBrowser ? fn : noop;

export { browserAction };
//# sourceMappingURL=browserAction.js.map
